export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080/v1' : 'https://api.freshspire.io/v1';
